import { render, staticRenderFns } from "./selection-proxy.vue?vue&type=template&id=74653edc&scoped=true&"
import script from "./selection-proxy.vue?vue&type=script&lang=js&"
export * from "./selection-proxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74653edc",
  null
  
)

export default component.exports